import { render } from "./PremiumImpactResult.vue?vue&type=template&id=6bc5180e&scoped=true"
import script from "./PremiumImpactResult.vue?vue&type=script&lang=js"
export * from "./PremiumImpactResult.vue?vue&type=script&lang=js"

import "./PremiumImpactResult.vue?vue&type=style&index=0&id=6bc5180e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc5180e"]])

export default __exports__